// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"661":"44ac4fbe0635d95f","672":"28fb3e906d0c6972","761":"1a57be0f3bc71bbb","990":"cadc683e139c997e"}[chunkId] + ".js";
};